<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-text
            class="mt-3"
            name="code"
            label="* Code"
            v-model="form.code"
            :error="errors.code ? errors.code[0] : null"
            :maxlength="255"
        />

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Currency</p>
            <reference
                link-text="Link an existing currency"
                v-model="form.currency"
                model-data="Currency"
                :should-open-new-window="true"
                :language="form.language"
                :creatable="false"
                :order="{
                    'name': 'asc'
                }"
                :error="errors.currency_id ? errors.currency_id[0] : null"
            />
        </div>


        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>
<script>
import crudForm from '../mixins/crudForm';

export default {
    name: "CountryForm",
    mixins: [crudForm],
    data(){
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData('name'),
                code: this.getFormData('code'),
                currency_id: this.getFormData('currency_id'),
                currency: this.getFormData('currency'),
            }
        }
    },
    watch: {
        "form.currency": function (newValue) {
            this.form.currency_id = newValue ? newValue.id : null;
        },
    }
}
</script>
